import { Link } from 'react-router-dom';

function id(original) {
  return original?.id || '';
}

function name(original) {
  return (
    <Link to={`/serviceproviders/edit/${original?.id}`}>
      {original?.name || ''}
    </Link>
  );
}

function accountNumber(original) {
  return original?.accountNumber || '';
}

function status(original) {
  switch (original?.status) {
    case 'ACTIVE':
      return 'Active';
    case 'INACTIVE':
      return 'In-Active';
    default:
      return 'Unknown';
  }
}

export { id, name, accountNumber, status };
